<template>
    <div class="home">
        <div
                class=" flex flex-col sticky z-10 shadow bg-white mb-12 w-full"
                style="top: 50px"
        >
            <div class="flex px-8 items-center py-4 mb-4 justify-between">
                <div class="page-heading text-2xl font-semibold">Labels</div>

            </div>
        </div>
        <div class="px-8">
            <table v-if="filteredRecords.length > 0" class="table-auto w-full">
                <thead>
                <tr>
                    <th class="px-4 py-1">sn</th>
                    <th class="w-8/12 px-4 py-1">Label Text</th>
                    <th class="w-8/12 px-4 py-1">Label Type</th>
                    <th class="py-2 w-2/12 text-elft">...</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(x, index) in filteredRecords" :key="index">
                    <td class="px-4 border-b py-5 text-center">{{ index + 1 }}</td>

                    <td class="px-4 border-b py-5 text-center">{{ `${x.label_text}` }}</td>
                    <td class="px-4 border-b py-5 text-center">{{ `${x.label_type}` }}</td>
                    <td class="px-4 border-b py-5 text-left">
                        <a
                                style="cursor: pointer"
                                @click="
                  $router.push({
                    name: 'tenant-labels-update',
                    params: { id: x.id },
                  })
                "
                                class="text-green-600"
                        >Edit</a
                        >
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="text-center text-2xl font-semibold text-black" v-else>
               <empty message="no label found"/>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions, mapMutations } from "vuex";
    import Empty from "../../../components/general/Empty";
    export default {
        data() {
            return {
                quickSearch: "",
                list: [],
            };
        },
        computed: {
            filteredRecords() {
                let data = this.list.filter((row) => {
                    return Object.keys(row).some((key) => {
                        return (
                            String(row[key])
                                .toLowerCase()
                                .indexOf(this.quickSearch.toLowerCase()) > -1
                        );
                    });
                });

                return data;
            },
        },
        components: {
            Empty,
            card: () => import("@/components/tenant/reward-card"),
            lbutton: () => import("@/components/general/button"),
        },
        methods: {
            ...mapActions(["fetchLabels"]),
            ...mapMutations(["updateLoader"]),
        },
        async mounted() {
            this.updateLoader(true);
            let res = await this.fetchLabels();
            this.list = res.data.data.labels
            this.updateLoader(false);
        },
    };
</script>
